module.exports = __webpack_public_path__ + "static/media/companyculture02.06d4a82c.png";